export default "__VITE_ASSET__FtszSoWy__"